import { render, staticRenderFns } from "./ConvoView.vue?vue&type=template&id=4f873397&"
import script from "./ConvoView.vue?vue&type=script&lang=js&"
export * from "./ConvoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports